import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		width: "100%",
		position: "relative",
		backgroundColor: theme.palette.colors.white,
		border: `1px solid ${theme.palette.colors.disabled}`,
		borderTop: "none",
		boxShadow: "inset 0 -5px 5px 0 rgba(0, 0, 0, 0.05)",
		display: "flex",
		"&:first-child": {
			borderRadius: "10px 10px 0 0",
			borderTop: `1px solid ${theme.palette.colors.disabled}`,
		},
		"&:last-child": {
			borderRadius: "0 0 10px 10px",
			boxShadow: "none",
		},
	},
	cell: {
		borderRight: `1px solid ${theme.palette.colors.disabled}`,
		padding: "22px 36px",
		"&:last-child": {
			borderRight: "none",
		},
	},
	logoCell: {
		width: "25%",
		borderRight: `1px solid ${theme.palette.colors.disabled}`,
		padding: "22px 36px",
		"&:last-child": {
			borderRight: "none",
		},
	},
	buttonsCell: {
		width: "25%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	numberCell: {
		width: "25%",
	},
	priceCell: {
		width: "25%",
	},
	logo: {},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		cell: {
			padding: "22px 33px",
		},
		logoCell: {
			width: "20%",
			padding: "22px 33px",
		},
		buttonsCell: {
			width: "30%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		numberCell: {
			width: "30%",
		},
		priceCell: {
			width: "20%",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		cell: {
			padding: "16px 25px",
		},
		logoCell: {
			width: "20%",
			padding: "16px 25px",
		},
		buttonsCell: {
			width: "30%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		numberCell: {
			width: "30%",
		},
		priceCell: {
			width: "20%",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			borderTop: `1px solid ${theme.palette.colors.disabled}`,
			boxShadow: "none",
			display: "flex",
			borderRadius: "10px",
			flexWrap: "wrap",
			marginBottom: "16px",
			"&:first-child": {
				borderRadius: "10px",
			},
			"&:last-child": {
				borderRadius: "10px",
				boxShadow: "none",
			},
		},
		cell: {
			padding: "15px 20px",
			borderRight: "none",
			borderBottom: `1px solid ${theme.palette.colors.disabled}`,
			"&:last-child": {
				borderRight: "none",
				borderBottom: "none",
			},
		},
		logoCell: {
			padding: "0",
			borderRight: "none",
		},
		buttonsCell: {
			width: "100%",
			flexDirection: "column",
			alignItems: "center",
			display: "flex",
			padding: 0,
		},
		numberCell: {
			width: "100%",
		},
		priceCell: {
			padding: "15px 28px!important",
			width: "100%",
		},
		logo: {
			display: "block",
			position: "absolute",
			right: "20px",
			top: "9px",
		},
	},
});

const Component = ({
	classes,
	priceComponent,
	numberComponent,
	buttonComponent,
	logoComponent,
}) => (
	<div className={classes.root}>
		<div className={classNames(classes.numberCell, classes.cell)}>{numberComponent}</div>
		<div className={classNames(classes.logoCell)}>
			<div className={classes.logo}>{logoComponent}</div>
		</div>
		<div className={classNames(classes.priceCell, classes.cell)}>{priceComponent}</div>
		<div className={classNames(classes.buttonsCell, classes.cell)}>{buttonComponent}</div>
	</div>
);

export default withStyles(styles)(Component);
